import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 mt-16"
    >
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-blue-600 text-white">
                <FileText className="w-4 h-4" />
              </span>
              <span className="font-heading font-extrabold text-lg text-slate-900 dark:text-white">
                ActeSimplu
              </span>
            </div>
            <p className="text-sm text-slate-500 dark:text-slate-400 max-w-xs">
              Generează online documente administrative personalizate, în format
              PDF și Word. Plată unică, fără abonament.
            </p>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-slate-900 dark:text-white mb-3 text-sm">
              Platformă
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#documente" className="text-slate-500 hover:text-blue-600">Documente</a></li>
              <li><Link to="/cum-functioneaza" className="text-slate-500 hover:text-blue-600">Cum funcționează</Link></li>
              <li><Link to="/intrebari-frecvente" className="text-slate-500 hover:text-blue-600">Întrebări frecvente</Link></li>
              <li><Link to="/contact" className="text-slate-500 hover:text-blue-600">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-slate-900 dark:text-white mb-3 text-sm">
              Legal
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/termeni" className="text-slate-500 hover:text-blue-600">Termeni și condiții</Link></li>
              <li><Link to="/confidentialitate" className="text-slate-500 hover:text-blue-600">Politica de confidențialitate</Link></li>
              <li><Link to="/cookie" className="text-slate-500 hover:text-blue-600">Politica de cookie-uri</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-200 dark:border-slate-800">
          <p className="text-xs text-slate-400 leading-relaxed">
            ActeSimplu generează modele de documente pe baza informațiilor introduse
            de utilizator. Documentele nu constituie consultanță juridică, fiscală
            sau profesională. Verifică informațiile înainte de utilizare.
          </p>
          <p className="text-xs text-slate-400 mt-3">
            © {new Date().getFullYear()} ActeSimplu. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>
  );
};
